/* eslint-disable import/prefer-default-export */
export enum NotificationIcon {
    Success = 'SUCCESS',
    Info = 'INFO',
    Warning = 'WARNING',
    Danger = 'DANGER',
    Logout = 'LOGOUT',
}
